<template>
  <v-pagination
    v-model="page"
    :length="length"
    @input="$emit('page-change', page)"
  />
</template>

<script>
export default {
  name: "NodePaginator",
  props: {
    totalEntries: {
      type: Number,
      required: true
    },
    perPage: {
      type: Number,
      default: 10
    },
    currentPage: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      page: 1,
    }
  },
  mounted() {
    this.page = this.currentPage;
  },
  computed: {
    length() {
      return Math.ceil(this.totalEntries / this.perPage);
    }
  }
}
</script>